import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ToastProvider } from './hooks/useToast.tsx'
import { LocaleProvider } from './hooks/useLocale.tsx'
import { MoneyVisibilityProvider } from './hooks/useMoneyVisibility.tsx'
import './index.css'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <LocaleProvider>
      <MoneyVisibilityProvider>
        <BrowserRouter>
          <ToastProvider>
            <App />
          </ToastProvider>
        </BrowserRouter>
      </MoneyVisibilityProvider>
    </LocaleProvider>
  </StrictMode>,
)
